/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Sparkle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Sparkle 24">
      <path
        fill="#5E1FF0"
        d="M8.318 7.517c.194-.69 1.17-.69 1.364 0l.63 2.248a5.663 5.663 0 0 0 3.923 3.922l2.248.631c.69.194.69 1.17 0 1.364l-2.248.63a5.663 5.663 0 0 0-3.922 3.923l-.631 2.248c-.194.69-1.17.69-1.364 0l-.63-2.248a5.664 5.664 0 0 0-3.923-3.922l-2.248-.631c-.69-.194-.69-1.17 0-1.364l2.248-.63a5.663 5.663 0 0 0 3.922-3.923l.631-2.248Z"
        className="Star 10"
      />
      <path
        fill="#5E1FF0"
        d="M17.574 1.323c.12-.43.731-.43.852 0l.395 1.405a3.54 3.54 0 0 0 2.45 2.451l1.406.395c.43.12.43.731 0 .852l-1.405.395a3.54 3.54 0 0 0-2.451 2.45l-.395 1.406c-.12.43-.731.43-.852 0l-.395-1.405a3.54 3.54 0 0 0-2.45-2.451l-1.406-.395c-.43-.12-.43-.731 0-.852l1.405-.395a3.54 3.54 0 0 0 2.452-2.45l.394-1.406Z"
        className="Star 12"
      />
    </g>
  </svg>
);

export const SparkleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'sparkle-icon'}
      icon={Sparkle}
      {...props}
      size={size}
    />
  );
};
